(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    (function() {
    const sectionId = '{{ section.id }}';
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    const timelineSection = section?.classList.contains('section-with-timeline');
    
    if (!timelineSection) return;

    const boat = document.getElementById(`timeline-boat-${sectionId}`);
    const content = document.getElementById(`timeline-content-${sectionId}`);
    const tiles = content?.querySelectorAll('.group-block');
    
    if (!boat || !content || !tiles || tiles.length === 0) return;

    let activeTileIndex = 0;
    let ticking = false;

    function updateBoatPosition() {
      if (!tiles.length) return;

      // Get first and last tiles
      const firstTile = tiles[0];
      const lastTile = tiles[tiles.length - 1];
      
      if (!firstTile || !lastTile) return;

      const firstTileRect = firstTile.getBoundingClientRect();
      const lastTileRect = lastTile.getBoundingClientRect();
      
      // Get absolute positions (relative to document)
      const firstTileTop = firstTileRect.top + window.scrollY;
      const firstTileBottom = firstTileRect.bottom + window.scrollY;
      const lastTileTop = lastTileRect.top + window.scrollY;
      const lastTileBottom = lastTileRect.bottom + window.scrollY;
      
      // Get progress bar element and position
      const progressBar = boat?.parentElement;
      if (!progressBar) return;
      
      let positionPercent = 77; // fixed at 77%
      const timelinePosition = progressBar.dataset.timelinePosition;
      if (timelinePosition !== undefined && timelinePosition !== null && timelinePosition !== '') {
        positionPercent = parseFloat(timelinePosition);
        if (isNaN(positionPercent)) {
          positionPercent = 77;
        }
      }
      
      // Get top padding from data attribute (section top padding + 25px)
      const topPadding = parseFloat(progressBar.dataset.topPadding) || 0;
      
      // Calculate progress bar start (top 25% of first card + top padding) and end (bottom 25% of last card) in absolute coordinates
      const contentRect = content.getBoundingClientRect();
      const contentTop = contentRect.top + window.scrollY;
      const progressBarStartAbsolute = firstTileTop + (firstTileRect.height * 0.25);
      const progressBarEndAbsolute = lastTileBottom - (lastTileRect.height * 0.25);
      const progressBarHeightAbsolute = progressBarEndAbsolute - progressBarStartAbsolute;
      
      // Calculate scroll progress based on viewport center position
      const viewportCenter = window.scrollY + window.innerHeight / 2;
      
      let scrollProgress = 0;
      if (viewportCenter <= progressBarStartAbsolute) {
        scrollProgress = 0;
      } else if (viewportCenter >= progressBarEndAbsolute) {
        scrollProgress = 1;
      } else {
        const progressRange = progressBarEndAbsolute - progressBarStartAbsolute;
        if (progressRange > 0) {
          scrollProgress = (viewportCenter - progressBarStartAbsolute) / progressRange;
        }
      }
      
      // Update progress bar position and height (relative to content container)
      if (content) {
        // Progress bar starts at: section top padding + 25px from top of content
        // Progress bar height: 80% of the calculated height (from first tile 25% to last tile 25%)
        const progressBarHeight = progressBarHeightAbsolute * 0.8;
        
        progressBar.style.top = `${topPadding}px`;
        progressBar.style.height = `${progressBarHeight}px`;
        progressBar.style.bottom = 'auto';
        progressBar.style.left = `${positionPercent}%`;
      }
      
      // Find which tile is in the viewport center
      const viewportMiddle = window.scrollY + window.innerHeight / 2;
      let newActiveIndex = 0;
      let minDistance = Infinity;

      tiles.forEach((tile, index) => {
        const tileRect = tile.getBoundingClientRect();
        const tileTop = tileRect.top + window.scrollY;
        const tileBottom = tileTop + tileRect.height;
        const tileCenter = tileTop + tileRect.height / 2;
        
        const distance = Math.abs(viewportMiddle - tileCenter);
        
        if (viewportMiddle >= tileTop && viewportMiddle <= tileBottom) {
          if (distance < minDistance) {
            minDistance = distance;
            newActiveIndex = index;
          }
        }
      });

      // Update active tile
      if (newActiveIndex !== activeTileIndex) {
        tiles.forEach((tile, index) => {
          if (index === newActiveIndex) {
            tile.classList.add('active-tile');
          } else {
            tile.classList.remove('active-tile');
          }
        });
        activeTileIndex = newActiveIndex;
      }

      // Update progress bar fill and boat position
      const progressFill = document.getElementById(`timeline-progress-fill-${sectionId}`);
      const progressTrack = progressBar.querySelector('.section-timeline-progress-track');
      
      if (progressFill && progressTrack && boat) {
        // Ensure minimum 5% progress, then update based on scroll
        const minProgress = 0.05; // 5%
        const finalProgress = Math.max(minProgress, scrollProgress);
        const fillHeight = finalProgress * 100;
        progressFill.style.height = `${fillHeight}%`;
        
        // Position boat at the boundary between filled and empty (at the bottom of the fill)
        // The fill grows from top to bottom, so the boat should be at the bottom edge of the fill
        const trackHeight = progressTrack.offsetHeight;
        const boatTop = (finalProgress * trackHeight);
        boat.style.top = `${boatTop}px`;
        boat.style.left = `${positionPercent}%`;
      }

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateBoatPosition);
        ticking = true;
      }
    }

    // Initial update
    updateBoatPosition();

    // Listen to scroll events
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateBoatPosition, { passive: true });

    // Update on intersection observer for better performance
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          updateBoatPosition();
        }
      });
    }, {
      rootMargin: '-20% 0px -20% 0px'
    });

    observer.observe(content);
  })();
  } catch(e) { console.error(e); }
})();

})();
